import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppState } from 'src/reducers';

import LoginPromoModal from 'src/components/modal/login-promo';
import { createAlertRequest } from 'src/areas/sidebar/actions/alert';

import { ProductAlert, ProductAlertForm } from '../product-alert-form';
import { ProductAlertInfo } from '../product-alert-info';

import { ProductAlertFormData } from '../../types';

type Props = {
  productAlertFormData: ProductAlertFormData;
  privacyPolicyUri?: string;
  isEdit?: boolean;
  onClose?: () => void;
  onCreate?: () => void;
};

export const CreateAlert = (props: Props) => {
  const {
    productAlertFormData,
    privacyPolicyUri,
    isEdit = false,
    onClose,
    onCreate,
  } = props;

  const dispatch = useDispatch();

  const [showLoginPromo, setShowLoginPromo] = React.useState<boolean>(false);
  const onCreateHandler = (productAlert: ProductAlert) =>
    dispatch(createAlertRequest(productAlert, onCreate || onClose));

  const sending = useSelector(
    (state: AppState) => state.areas.productAlert.sending
  );
  const error = useSelector(
    (state: AppState) => state.areas.productAlert.error
  );

  return (
    <>
      <LoginPromoModal
        isOpen={showLoginPromo}
        onRequestClose={() => setShowLoginPromo(false)}
      />
      <ProductAlertInfo productAlertFormData={productAlertFormData} />
      <ProductAlertForm
        productAlertFormData={productAlertFormData}
        disabled={sending}
        error={error}
        onClose={onClose}
        onCreate={onCreateHandler}
        privacyPolicyUri={privacyPolicyUri}
        isEdit={isEdit}
        shouldAutoFocus
      />
    </>
  );
};
